module.exports = __webpack_public_path__ + "img/changes.50032181.svg";